import { Service } from "./common";
import type { PushToken } from "./types/push-token";

export type { PushToken } from "./types/push-token";

export class PushTokenService extends Service<PushToken> {
  constructor() {
    super("/push-tokens");
  }
}

export const pushTokenService = new PushTokenService();
